import { PublicKey } from "@solana/web3.js";
import { CoolProgram } from "../backend/target/types/cool_program.ts";
import idl from "../backend/target/idl/cool_program.json";

export const SOLANA_CLUSTERS_RPC = {
    MAIN_NET: "https://api.mainnet-beta.solana.com",
    DEV_NET: "https://api.devnet.solana.com",
    TEST_NET: "https://api.testnet.solana.com",
    LOCAL_NET: "http://localhost:8899",
};

export const DERIVATION_PATHS = {
    SOLANA: {
        standard: "m/44'/501'/x'/0'",
        legacy: "m/44'/501'/x'",
        backpack_legacy: "m/44'/501'/0'/0'/x'",
        ledger_live: "m/44'/501'/x'/0'/0'",
    },
};
export const OnPopUpPageLoadMessage = "loaded";
export const idl_json: CoolProgram = JSON.parse(JSON.stringify(idl));
export const programId = new PublicKey(idl_json.address);
export const USDCMint = new PublicKey("4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU"); // devnet
export const USDCLogo =
    "https://raw.githubusercontent.com/solana-labs/token-list/main/assets/mainnet/4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU/logo.png";
export const CURRENCIES = {
    USD: { currency: "USD", symbol: "$", locale: "en-US" },
    // EUR: { currency: 'EUR', symbol: '€', locale: 'de-DE' },
    RUB: { currency: "RUB", symbol: "₽", locale: "ru-RU" },
    // JPY: { currency: 'JPY', symbol: '¥', locale: 'ja-JP' },
    // GBP: { currency: 'GBP', symbol: '£', locale: 'en-GB' },
};
